import { render } from "./Nhl.vue?vue&type=template&id=68f3e1e1&scoped=true"
import script from "./Nhl.vue?vue&type=script&lang=js"
export * from "./Nhl.vue?vue&type=script&lang=js"

import "./Nhl.vue?vue&type=style&index=0&id=68f3e1e1&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-68f3e1e1"]])

export default __exports__